import React from 'react';
import { NavLink } from 'react-router-dom';
import Toolbar from '@material-ui/core/Toolbar';
import { makeStyles } from '@material-ui/core/styles';
import logo from 'src/data/logo';
import NavDrawer from './_nav-drawer';

const useStyles = makeStyles(() => ({
  navDisplayFlex: {
    display: 'flex',
    flexGrow: 1
  },
  linkText: {
    textDecoration: 'none',
    textTransform: 'uppercase',
    color: 'white'
  },
}));

const AppBarMobile = () => {
  const classes = useStyles();

  return (
    <>
      <Toolbar disableGutters>
        <NavLink
          className={classes.navDisplayFlex}
          style={{padding: 0, margin: 0}}
          to={'/home'}
        >
          <img
            alt={logo.alt}
            src={logo.img}
            style={{height: '1rem'}}
            title={logo.title}
          />
        </NavLink>
        <NavDrawer />
      </Toolbar>
    </>
  );
}

export default AppBarMobile;
